import * as moment from 'moment';

export const date2id = (date: Date): string => {
  if (date) {
    return moment(date).format('YYYYMMDD');
  } else {
    return '';
  } // else
};
